import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="tos-acceptance"
export default class extends Controller {
  static targets = [
    'checkbox',
    'button',
  ]

  declare readonly checkboxTarget: HTMLInputElement
  declare readonly buttonTarget: HTMLButtonElement

  connect () {
    this.toggleButtonState()
  }

  toggleButtonState () {
    const isChecked = this.checkboxTarget.checked
    this.buttonTarget.disabled = !isChecked
  }
}
